/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface MasqLinkArgs {
  route: string;
  routeModel: (string | number)[];
  label: string;
  icon?: string;
  value: string;
}

export default class MasqLink extends Component<MasqLinkArgs> {}
